module.exports = __webpack_public_path__ + "static/tacoma0-7239dcd0aa96560f46a05daf3a06ad65.png";